<template>
<v-container ref="pageBankProduct" fluid tag="section">
    <material-card icon="mdi-credit-card-multiple" icon-small title="Банківскі продукти" color="accent" class="mb-16">
    </material-card>
    <v-simple-table>
        <thead>
            <tr>
                <th class="primary--text" width="20">
                    ID
                </th>
                <th class="primary--text" width="50%">
                    Назва
                </th>
                <th class="primary--text" width="30%">
                    Код
                </th>
                <th class="primary--text" width="20%">
                    Кількість платежів
                </th>
                <th class="primary--text" width="10">
                    Включено
                </th>
                <th width="50"></th>
            </tr>
        </thead>

        <tbody v-if="bankProduct.length">
            <tr v-for="(bank, index) in bankProduct" :key="bank.id">
                <td>{{ bank.id }}</td>
                <td>{{ bank.name }}</td>
                <td>{{ bank.code }}</td>
                <td>{{ bank.number_of_payments }}</td>
                <td><v-icon v-if="bank.enabled">mdi-check</v-icon></td>
                <td>
                    <span class="d-flex">
                        <v-icon v-if="isManager || isAdmin" class="mr-4" color="green" @click="$router.push(`/bank-product/${bank.id}/`)">
                            mdi-pencil
                        </v-icon>
                        <v-icon v-if="isAdmin" color="error" @click="deleteBank(bank.id)">
                            mdi-delete
                        </v-icon>
                    </span>
                </td>
            </tr>
        </tbody>
    </v-simple-table>

    <!--Пагинация-->
    <div v-if="pagesCount >= 1" class="text-center py-4">
        <v-pagination @input="setQueryParam(pageCurrent)" v-model="pageCurrent" :total-visible="9" :length="pagesCount"></v-pagination>
    </div>
    <DialogConfitmDelete ref="dialogConfirmDelete" />
    <Preloader v-if="isSending" />
    <v-btn
      v-if="isManager || isAdmin"
      class="add-user__button"
      fab
      dark
      color="primary"
      to="/bank-product/add/"
    >
      <v-icon dark>
        mdi-plus
      </v-icon>
    </v-btn>


</v-container>
</template>
<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { IMAGE_BASE_URL } from '@/env.config';

  export default {
    name: 'RegularTablesView',
    data() {
      return {
        // Список банків
        bankProduct: [],
        // Тецущий проект
        project: {},
        mis: null,
        // Текущая страница
        pageCurrent: null,
        // Количество акций на странице
        pageLimitItems: 10,
        // Количество страниц
        pagesCount: 1,
        // Выполняется отправка на сервер
        isSending: false,
        imageBaseUrl: `${IMAGE_BASE_URL}bank-product/`
      }
    },
    computed: {
      ...mapGetters(['isManager', 'isAdmin', 'projects']),
    },

    mounted() {
      this.init();
    },

    watch: {
      // Сделано через watch  чтобы отслеживать переходы вне страницы (например если пользователь нажмёт в меню /bankProduct/)
      '$route': {
        handler() {
          this.getbankProduct();
        },
        deep: true,
      }
    },

    methods: {
      ...mapMutations(['setSnackbar']),
      ...mapActions(['getProjects']),

      async init() {
        await this.getProjects();
        await this.getbankProduct();
      },

      // Получить список 
      async getbankProduct() {
        let { project = null, type = null, mechanic = null, mis = null, page = 1 } = this.$route.query;
        this.project = this.projects.find((el) => el.id == project);
        this.mis = mis;
        this.pageCurrent = +page;

        try {
          let { data } = await HTTP.post('/get-list-bank-product', { 
            limit: this.pageLimitItems,
            page,
          });

          this.bankProduct = data?.content?.data || [];
          this.pagesCount = data?.content?.pagination?.pages || 1;
        } catch(error) {
          console.warn(error);
        }
      },
      // Добавляем query параметры в урл
      setQueryParam(page = 1) {
        this.pageCurrent = page;
        let query = {
          project: this.project?.id,
          mis: this.mis,
          page: this.pageCurrent
        };

        for(let key in query) {
          if (!query[key] || (key === 'page' &&  query?.page <= 1)) {
            delete query[key];
          }
        };

        let query1 = JSON.stringify(query).split('"').join('');
        let query2 = JSON.stringify(this.$route.query).split('"').join('');

        if (query1 != query2) {
          this.$router.push({ query });
        }
        return query;
      },

      // Удалить bank
      async deleteBank(bankId) {
        let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
        if (!isConfirmDelete) return;
        this.isSending = true;

        try {
          await HTTP.post('/delete-bank-product', { id: bankId });
          this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
          this.getbankProduct();
        } catch(error) {
          console.warn(error);
          this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
        } finally {
          this.isSending = false;
        }
      },
    },
  }

</script>

<style>
.add-user__button {
  position: fixed;
  bottom: 20px;
  right: 20px;
}
</style>

